export enum PoolActionType {
  SetState = 'POOL.SET_STATE',
  GET_POOL_LIST = 'POOL.GET_POOL_LIST',
  GET_POOL_STATISTIC = 'POOL.GET_POOL_STATISTIC',
  GET_POOL_USERS = 'POOL.GET_POOL_USERS',
}
